var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1532 21.2251C27.1349 18.0595 28.5495 15.6736 31.4062 13.9144C29.8085 11.5936 27.3913 10.3171 24.205 10.0711C21.1882 9.8297 17.8874 11.8535 16.6789 11.8535C15.4016 11.8535 12.4809 10.1546 10.1827 10.1546C5.43994 10.2289 0.399597 13.9887 0.399597 21.6383C0.399597 23.8988 0.807036 26.2336 1.62191 28.638C2.71147 31.8036 6.63937 39.56 10.7366 39.4346C12.8791 39.3836 14.3944 37.8936 17.1824 37.8936C19.888 37.8936 21.2889 39.4346 23.6786 39.4346C27.8125 39.3743 31.365 32.3235 32.3996 29.1486C26.8557 26.4981 27.1532 21.3876 27.1532 21.2251ZM22.3418 7.06787C24.6628 4.27355 24.4522 1.72988 24.3836 0.81546C22.3326 0.936145 19.9613 2.23119 18.6108 3.8233C17.1229 5.53146 16.2485 7.64344 16.4362 10.0247C18.652 10.1964 20.6754 9.0406 22.3418 7.06787Z",
    fill: "#EB7F2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.93e2b9926a5660ab49331d498ac82cf1.svg";
export { ForwardRef as ReactComponent };